import React from 'react';

import { Currencies } from 'src/enums';
import { CurrencySymbols } from 'src/constants/currencySymbols';
import { pluralise, numberToDecimalString } from 'src/utils';

import { IconButton } from '../../IconButton';
import { IconName } from '../../Icon';

import { ProductPriceInterface } from './BookingSummary.interface';
import * as S from './BookingSummaryCategory.style';

const tranformDiscountValue = (value, currencySymbol) =>
  `-${currencySymbol}${numberToDecimalString(value * -1)}`;

export const BookingSummaryCategorySection = ({
  onDiscountInfoClick,
  showDetailedPrice,
  showQuantity,
  bold,
  currency,
  showCurrency,
  showNetPrice,
  prepaid,
  included,
  ...productPrice
}: ProductPriceInterface & {
  onDiscountInfoClick?: () => any;
  showDetailedPrice?: boolean;
  showQuantity?: boolean;
  bold?: boolean;
  currency?: Currencies;
  showCurrency?: boolean;
  showNetPrice?: boolean;
}) => {
  const currencySymbol =
    CurrencySymbols[currency] ?? CurrencySymbols[Currencies.NZD];

  let catergoryNameText = productPrice?.name;

  if (showDetailedPrice) {
    catergoryNameText = `${productPrice?.duration?.length} ${pluralise(
      productPrice?.duration?.unit,
      productPrice?.averagePrice,
    )} at average of ${currencySymbol}${numberToDecimalString(
      productPrice?.averagePrice,
    )}`;
  } else if (showQuantity && !!productPrice?.quantity) {
    catergoryNameText = `${productPrice.quantity} x ${productPrice?.name}`;
  }

  const categoryPriceText = prepaid
    ? 'Prepaid'
    : included
    ? 'Included'
    : `${showCurrency ? currency : ''}${currencySymbol}${
        showNetPrice
          ? numberToDecimalString(productPrice?.netPrice)
          : numberToDecimalString(productPrice?.grossPrice)
      }`;

  return (
    <S.BookingSummaryCategorySectionWrapper
      data-test-id={`Price-Summary-${catergoryNameText}`}
    >
      <S.BookingSummaryCategoryPriceSection>
        <S.BookingSummaryColumnSection>
          <S.BookingSummaryCategorySpan bold={bold}>
            {catergoryNameText}
          </S.BookingSummaryCategorySpan>
        </S.BookingSummaryColumnSection>
        <S.BookingSummaryColumnSection textAlign={'end'}>
          <S.BookingSummaryCategorySpan bold={bold}>
            {categoryPriceText}
          </S.BookingSummaryCategorySpan>
        </S.BookingSummaryColumnSection>
      </S.BookingSummaryCategoryPriceSection>
      {productPrice?.minCharge && (
        <BookingSummaryCategorySection
          {...productPrice?.minCharge}
          prepaid={prepaid}
          included={included}
          netPrice={productPrice?.minCharge?.amount}
          currency={currency}
          showNetPrice
        />
      )}
      {productPrice.discounts &&
        productPrice.discounts.length > 0 &&
        productPrice.discounts.map((discount, index) => (
          <S.BookingSummaryCategoryPriceSection
            key={`${productPrice.name}-discount-${index}`}
          >
            <S.BookingSummaryColumnSection>
              <S.BookingSummaryDiscountSpan>
                {discount.name}
              </S.BookingSummaryDiscountSpan>
              {onDiscountInfoClick && (
                <IconButton
                  name={IconName.infoEmpty}
                  onClick={() => onDiscountInfoClick()}
                  color={'b2cRed'}
                  wrapperStyle={{
                    width: '1.6rem',
                    height: '1.8rem',
                  }}
                />
              )}
            </S.BookingSummaryColumnSection>
            <S.BookingSummaryColumnSection textAlign={'end'}>
              <S.BookingSummaryDiscountSpan>
                {prepaid || included
                  ? 'Prepaid'
                  : tranformDiscountValue(discount.amount, currencySymbol)}
              </S.BookingSummaryDiscountSpan>
            </S.BookingSummaryColumnSection>
          </S.BookingSummaryCategoryPriceSection>
        ))}
    </S.BookingSummaryCategorySectionWrapper>
  );
};
